import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecg-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
